import { object } from "prop-types";
import { observer } from "mobx-react";
import {
  usePresetFieldNames,
  useEstimateEditorStore,
  useVisibilityModeCellClassName,
  useEstimateEditorSettings,
  useEstimateTableSettings,
  ValueCell,
  VisibilityButton,
} from "@tools";

export const CombinedHeaderWorkType = observer(({
  section,
  ...cellProps
}) => {
  const { isProposal } = useEstimateEditorSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const { totalWorkloadColumnMaxState } = useEstimateTableSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const { areAllWorkTypesOff, areAllWorkTypesHidden } = section;
  
  const className = useVisibilityModeCellClassName(areAllWorkTypesHidden);

  return (
    <ValueCell
      isHeader
      size={totalWorkloadColumnMaxState ? "large" : "medium"}
      visible={!areAllWorkTypesOff}
      className={className}
      {...cellProps}
    >
      <span className="preset-tableBreakdownHeader pt-combinedEstimate">
        { getFieldName("pt-combinedEstimate") }
      </span>
      {
        visibilityMode &&
        <VisibilityButton
          size="tiny"
          inColumn right={totalWorkloadColumnMaxState ? 2 : -12}
          hidden={areAllWorkTypesHidden}
          onChange={section.hideAllWorkTypes}
        />
      }
    </ValueCell>
  );
});

CombinedHeaderWorkType.propTypes = {
  section: object.isRequired,
};
